import { render } from "./KeyWordsComponent.vue?vue&type=template&id=e01d9d7a&scoped=true"
import script from "./KeyWordsComponent.vue?vue&type=script&lang=js"
export * from "./KeyWordsComponent.vue?vue&type=script&lang=js"

import "./KeyWordsComponent.vue?vue&type=style&index=0&id=e01d9d7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e01d9d7a"]])

export default __exports__